import { Routes } from '@angular/router';
import { LoginPageComponent } from './pages/login-page/login-page.component';
import { LayoutComponent } from './components/layout/layout.component';
import { DashboardPageComponent } from './pages/dashboard-page/dashboard-page.component';
import { BlockIfNotAuthenticatedGuard } from '@core/../platform/platform-core/user/guards/block-if-not-authenticated.guard';
import { BlockIfAuthenticatedGuard } from '@core/../platform/platform-core/user/guards/block-if-authenticated.guard';
import { FirstRouteGuard } from '@core/guards/first-route.guard';
import { LayoutStandaloneComponent } from '@core/components/layout-standalone/layout-standalone.component';
import { EGI_APP_ROOT } from '@ervo/page-framework';
import { RegisterPageComponent } from './pages/public-account/register-page/register-page.component';
import { VerifyPageComponent } from './pages/public-account/verify-page/verify-page.component';
import { ForgotPasswordPageComponent } from './pages/public-account/forgot-password-page/forgot-password-page.component';
import { ResetPasswordPageComponent } from './pages/public-account/reset-password-page/reset-password-page.component';
import { LegalPageComponent } from './pages/public-account/legal-page/legal-page.component';
import { redirectToPrivacyStatement } from './pages/public-account/legal-page/privacy-statement';
import { SharedChartPageComponent } from './pages/shared-chart-page/shared-chart-page.component';

export const coreRoutes: Routes = [
  {
    path: '',
    component: LayoutComponent,

    children: [
      {
        path: 'index',
        redirectTo: '',
        pathMatch: 'full'
      },
      {
        path: '',
        component: DashboardPageComponent,
        canActivate: [BlockIfNotAuthenticatedGuard, FirstRouteGuard],
        canActivateChild: [FirstRouteGuard]
      },
      {
        path: 'login',
        component: LoginPageComponent,
        canActivate: [BlockIfAuthenticatedGuard]
      },
      {
        path: 'register',
        component: RegisterPageComponent,
        canActivate: [BlockIfAuthenticatedGuard]
      },
      {
        path: 'verify',
        component: VerifyPageComponent
      },
      {
        path: 'forgot-password',
        component: ForgotPasswordPageComponent,
        canActivate: [BlockIfAuthenticatedGuard]
      },
      {
        path: 'reset-password',
        component: ResetPasswordPageComponent,
        canActivate: [BlockIfAuthenticatedGuard]
      },
      {
        path: 'terms',
        component: LegalPageComponent,
        data: { document: 'terms' }
      },
      {
        // Geen eigen pagina meer: de privacyverklaring staat centraal op de landing
        path: 'privacy',
        canActivate: [redirectToPrivacyStatement],
        children: []
      }
    ]
  },
  {
    // Gedeelde chart (spec 2026-10-20-chart-share §4.3): publiek, buiten de
    // guards; ingelogden worden door de pagina zelf naar de chartomgeving gestuurd.
    path: 'shared/:token',
    component: SharedChartPageComponent,
    data: {
      [EGI_APP_ROOT]: true
    }
  },
  {
    path:'standalone',
    component: LayoutStandaloneComponent,
    data: {
      [EGI_APP_ROOT]: true
    },
    children: []
  }
];
